import React from "react"

export const FooterSpacerMobile = () => (
  <hr className="is-hidden-desktop mt-1 mb-2" />
)
